<template>
  <!-- ============================================================ -->
  <!-- 物流页 — Logistics · Smart Fulfillment                        -->
  <!-- ============================================================ -->
  <div class="logi">
    <!-- ==================== 1. Hero ==================== -->
    <section class="logi-hero">
      <h2 class="logi-hero__tag">{{ $t('跨境物流 · 智能履约') }}</h2>
      <h1 class="logi-hero__title">{{ $t('全球智能物流网络') }}<br />{{ $t('让跨境发货快人一步') }}</h1>
      <p class="logi-hero__desc">{{ $t('整合国际专线、海外仓与多仓智能调度，覆盖200+国家，提供实时追踪与透明费率，助力DTC品牌高效履约。') }}</p>
      <div class="logi-hero__actions">
        <button class="logi-hero__btn logi-hero__btn--primary" @click="$router.push('/sign-up')">{{ $t('立即免费开通') }}</button>
      
      </div>
    </section>

    <!-- ==================== 2. Three Fulfillment Modes ==================== -->
    <section class="logi-modes">
      <div class="logi-modes__head">
        <div>
          <h2 class="logi-modes__title">{{ $t('跨境物流 · 灵活适配全球生意') }}</h2>
          <p class="logi-modes__sub">{{ $t('针对不同商品、时效、成本需求，提供三种专业履约模式') }}</p>
        </div>
        <button class="logi-btn-primary">
          <span>{{ $t('开始体验') }}</span>
          <img :src="require('@/assets/images/logistics/ThreeFulfillment-arrow.png')" alt="" />
        </button>
      </div>
      <div class="logi-modes__cards">
        <!-- International Line & Small Parcel -->
        <div class="logi-mode-card logi-mode-card--line" :class="{ 'logi-mode-card--expanded': expandedMode === 0 }" @mouseenter="expandedMode = 0">
          <img class="logi-mode-card__thumb" :src="require('@/assets/images/logistics/ThreeFulfillment-thumb-1.png')" alt="" />
          <h3 class="logi-mode-card__title">{{ $t('国际专线') }}<br />{{ $t('小包') }}</h3>
          <div class="logi-mode-card__body">
            <p class="logi-mode-card__desc">{{ $t('适合2kg以下轻小件，性价比高，清关稳定，主要服务于欧美、日韩、东南亚市场。') }}</p>
            <div class="logi-mode-card__feats">
              <div class="logi-mode-card__feat">
                <img :src="require('@/assets/images/logistics/ThreeFulfillment-check.png')" alt="" />
                <div>
                  <span>{{ $t('挂号/平邮可选，末端派送全程追踪') }}</span>
                  <span>{{ $t('云途、燕文、4PX 等深度合作') }}</span>
                  <span>{{ $t('妥投时效 7-15 个工作日') }}</span>
                </div>
              </div>
            </div>
          </div>
          <img class="logi-mode-card__more" :src="require('@/assets/images/logistics/ThreeFulfillment-more.png')" alt="" />
        </div>
        <!-- Overseas Warehouse -->
        <div class="logi-mode-card logi-mode-card--warehouse" :class="{ 'logi-mode-card--expanded': expandedMode === 1 }" @mouseenter="expandedMode = 1">
          <img class="logi-mode-card__thumb" :src="require('@/assets/images/logistics/ThreeFulfillment-thumb-2.png')" alt="" />
          <h3 class="logi-mode-card__title">{{ $t('海外仓') }}<br />{{ $t('本地发货') }}</h3>
          <div class="logi-mode-card__body">
            <p class="logi-mode-card__desc">{{ $t('提前备货至美、德、英、澳等海外仓，订单产生后本地派送，时效提升70%。') }}</p>
            <div class="logi-mode-card__feats">
              <div class="logi-mode-card__feat">
                <img :src="require('@/assets/images/logistics/ThreeFulfillment-check.png')" alt="" />
                <div>
                  <span>{{ $t('24h 出库，2-3 日达（美国）') }}</span>
                  <span>{{ $t('免头程管理，退货无忧') }}</span>
                  <span>{{ $t('显著降低关税争议，提升信任') }}</span>
                </div>
              </div>
            </div>
          </div>
          <img class="logi-mode-card__more" :src="require('@/assets/images/logistics/ThreeFulfillment-more.png')" alt="" />
        </div>
        <!-- Express Courier & Heavy Cargo -->
        <div class="logi-mode-card logi-mode-card--express" :class="{ 'logi-mode-card--expanded': expandedMode === 2 }" @mouseenter="expandedMode = 2">
          <img class="logi-mode-card__thumb" :src="require('@/assets/images/logistics/ThreeFulfillment-thumb-3.png')" alt="" />
          <h3 class="logi-mode-card__title">{{ $t('商业快递') }}<br />{{ $t('重货') }}</h3>
          <div class="logi-mode-card__body">
            <p class="logi-mode-card__desc">{{ $t('DHL/FedEx/UPS 官方账号对接，大货折扣，高价值商品首选，全球3-5日达。') }}</p>
            <div class="logi-mode-card__feats">
              <div class="logi-mode-card__feat">
                <img :src="require('@/assets/images/logistics/ThreeFulfillment-check.png')" alt="" />
                <div>
                  <span>{{ $t('自有账号绑定，享受协议价') }}</span>
                  <span>{{ $t('门到门，签收快') }}</span>
                  <span>{{ $t('支持大件、超长超重货物') }}</span>
                </div>
              </div>
            </div>
          </div>
          <img class="logi-mode-card__more" :src="require('@/assets/images/logistics/ThreeFulfillment-more.png')" alt="" />
        </div>
      </div>
    </section>

    <!-- ==================== 3. Smart Logistics Solution ==================== -->
    <section class="logi-solution">
      <div class="logi-solution__bg"></div>
      <div class="logi-solution__left">
        <h2 class="logi-solution__title">{{ $t('全链路跨境') }}<br />{{ $t('智慧物流解决方案') }}</h2>
        <p class="logi-solution__sub">{{ $t('整合多渠道物流与智能仓配，运费核算、物流动态一站式数字化管理') }}</p>
        <ul class="logi-steps">
          <li
            v-for="(step, idx) in solutionSteps"
            :key="step.label"
            :class="['logi-steps__item', { 'logi-steps__item--active': activeSolution === idx }]"
            @click="setSolution(idx)"
          >
            <span class="logi-steps__num">{{ pad(idx + 1) }}</span>
            <span class="logi-steps__label">{{ $t(step.label) }}</span>
          </li>
        </ul>
      </div>
      <div class="logi-solution__right">
        <div class="logi-solution__carousel">
          <div
            class="logi-solution__track"
            :style="{ transform: `translateX(-${trackOffset}%)` }"
          >
            <div v-for="step in solutionSteps" :key="step.label" class="logi-solution__slide">
              <img :src="step.img" alt="" />
              <h4 class="logi-solution__slide-title">{{ $t(step.label) }}</h4>
              <p class="logi-solution__slide-desc">{{ $t(step.desc) }}</p>
            </div>
          </div>
        </div>
        <div class="logi-solution__arrows">
          <button class="logi-solution__arrow" @click="prevSolution" :disabled="activeSolution === 0">
            <span class="logi-solution__arrow-icon logi-solution__arrow-icon--left"></span>
          </button>
          <button class="logi-solution__arrow" @click="nextSolution" :disabled="activeSolution === solutionSteps.length - 1">
            <span class="logi-solution__arrow-icon logi-solution__arrow-icon--right"></span>
          </button>
        </div>
      </div>
    </section>

    <!-- ==================== 4. Logistics Partners ==================== -->
    <section class="logi-partners">
      <h2 class="logi-partners__title">{{ $t('已对接全球主流物流服务商') }}</h2>
      <p class="logi-partners__sub">{{ $t('覆盖200+国家，一键选用，系统自动匹配最优渠道') }}</p>
      <div class="logi-partners__marquee">
        <div class="logi-partners__track">
          <img v-for="n in 2" :key="'a'+n" :src="require('@/assets/images/logistics/LogisticsPartners-'+n+'.png')" alt="" />
          <img v-for="n in 2" :key="'b'+n" :src="require('@/assets/images/logistics/LogisticsPartners-'+n+'.png')" alt="" />
        </div>
      </div>
    </section>

    <!-- ==================== 5. Multi-Warehouse Smart Network ==================== -->
    <section class="logi-warehouse">
      <h2 class="logi-warehouse__title">{{ $t('多仓智能网络 · 就近发货') }}</h2>
      <p class="logi-warehouse__sub">{{ $t('国内集货仓 + 核心海外仓 + 第三方仓API对接，订单自动路由至最优仓库') }}</p>
      <div class="logi-warehouse__carousel">
        <button class="logi-warehouse__arrow logi-warehouse__arrow--left" @click="prevWarehouse">
          <span class="logi-warehouse__arrow-icon"></span>
        </button>
        <div class="logi-warehouse__stage">
          <div
            v-for="(card, idx) in warehouseCards"
            :key="idx"
            class="logi-warehouse__card"
            :class="{
              'logi-warehouse__card--center': whPosition(idx) === 0,
              'logi-warehouse__card--side': whPosition(idx) !== 0
            }"
            :style="{
              transform: `translateX(${whPosition(idx) * whUnit}px) scale(${whPosition(idx) === 0 ? 1.06 : 0.78})`,
              opacity: whPosition(idx) === 0 ? 1 : 0.35,
              zIndex: whPosition(idx) === 0 ? 3 : 1,
              transition: 'transform 0.5s cubic-bezier(0.25,0.1,0.25,1), opacity 0.5s'
            }"
          >
            <img :src="card.img" alt="" />
            <div>
              <h4>{{ $t(card.title) }}</h4>
              <p v-for="line in card.lines" :key="line">{{ $t(line) }}</p>
            </div>
          </div>
        </div>
        <button class="logi-warehouse__arrow logi-warehouse__arrow--right" @click="nextWarehouse">
          <span class="logi-warehouse__arrow-icon"></span>
        </button>
      </div>
      <div class="logi-warehouse__tip">
        <img :src="require('@/assets/images/home/img-flag.png')" alt="" />
        <span>{{ $t('智能分配逻辑：根据买家地址、仓库库存、物流成本综合运算，自动选择成本/时效最优仓库发货。') }}</span>
      </div>
    </section>

    <!-- ==================== 6. Smart Shipping Calculator ==================== -->
    <section class="logi-calc">
      <h2 class="logi-calc__title">{{ $t('运费智能计算') }}</h2>
      <p class="logi-calc__sub">{{ $t('多种计费方式，灵活适配不同商品') }}</p>
      <div class="logi-calc__body">
        <div class="logi-calc__methods">
          <div v-for="m in methods" :key="m.title" class="logi-calc__method">
            <div class="logi-calc__method-head"><span class="logi-calc__method-icon">{{ m.icon }}</span><span>{{ $t(m.title) }}</span></div>
            <p>{{ $t(m.desc) }}</p>
          </div>
        </div>
        <div class="logi-calc__demo">
          <h4>{{ $t('运费计算演示') }}</h4>
          <div class="logi-calc__demo-inner">
            <label>{{ $t('选择重量 (kg)') }}</label>
            <div class="logi-calc__slider">
              <input type="range" v-model.number="demoWeight" min="0.1" max="20" step="0.1" />
              <span class="logi-calc__slider-val">{{ demoWeight }}kg</span>
            </div>
            <div class="logi-calc__weights">
              <span v-for="w in presetWeights" :key="w" :class="{ 'logi-calc__weight--active': demoWeight === w }" @click="demoWeight = w">{{ w }}kg</span>
            </div>
            <label>{{ $t('选择目的地') }}</label>
            <div class="logi-calc__dests">
              <span v-for="d in demoDests" :key="d.name" :class="{ 'logi-calc__dest--active': demoDest === d.name }" @click="demoDest = d.name">{{ $t(d.name) }}</span>
            </div>
            <div class="logi-calc__result">
              <span>{{ $t('预估运费') }}</span>
              <strong>￥{{ demoPrice }}</strong>
              <span>{{ $t('*仅供参考，实际以物流商报价为准') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="logi-calc__case">
        <div class="logi-calc__case-head"><span class="logi-calc__case-dot"></span><span>{{ $t('案例：某服饰卖家运费设置') }}</span></div>
        <p>{{ $t('按商品计算') }}</p>
        <div class="logi-calc__case-grid">
          <div v-for="c in cases" :key="c.region" class="logi-calc__case-item"><strong>{{ $t(c.region) }}</strong><span>{{ $t(c.rule) }}</span></div>
        </div>
        <div class="logi-calc__case-tip"><span class="logi-calc__case-dot"></span><span>{{ $t('买家下单时系统自动匹配最优惠运费方案') }}</span></div>
      </div>
    </section>

    <!-- ==================== 7. Real-Time Tracking ==================== -->
    <section class="logi-track">
      <h2 class="logi-track__title">{{ $t('实时追踪 · 全程可视化') }}</h2>
      <p class="logi-track__sub">{{ $t('买家端自动展示物流节点，卖家后台批量监控异常') }}</p>
      <img
        :src="stepImage"
        :alt="$t('实时追踪 · 全程可视化')"
        class="logi-track__img"
      />
    </section>

    <!-- ==================== 8. Smart Management System ==================== -->
    <section class="logi-manage">
      <h2 class="logi-manage__title">{{ $t('全链路物流追踪与智能管理系统') }}</h2>
      <p class="logi-manage__sub">{{ $t('多渠道轨迹同步、异常预警与多端查询，物流状态尽在掌握') }}</p>
      <div class="logi-manage__grid">
        <div v-for="m in manageItems" :key="m.title" class="logi-manage__card"><img :src="m.icon" alt="" /><span>{{ $t(m.title) }}</span><div class="logi-manage__bar"></div></div>
      </div>
    </section>

    <!-- ==================== 9. FAQ ==================== -->
    <section class="logi-faq">
      <h2 class="logi-faq__title">{{ $t('常见问题') }}</h2>
      <dl class="logi-faq__list">
        <div v-for="faq in faqs" :key="faq.q" class="logi-faq__item">
          <dt>{{ $t(faq.q) }}</dt>
          <dd v-if="faq.a">{{ $t(faq.a) }}</dd>
        </div>
      </dl>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Logistics',
  data() {
    return {
      expandedMode: 0,
      methods: [
        { title: '固定运费', desc: '所有订单统一运费，适合小商品、标准件', icon: '📦' },
        { title: '按重量计算', desc: '每XX kg收取XX元，适合按重量计价商品', icon: '⚖️' },
        { title: '按金额计算', desc: '满XX元包邮/满XX元减运费，适合促销活动', icon: '💰' },
        { title: '按地区计算', desc: '不同地区不同运费，适合多国家/多区域销售', icon: '🌐' },
        { title: '按商品计算', desc: '不同商品单独设置运费，适合大件/小件混卖', icon: '📋' },
      ],
      cases: [
        { region: '中国大陆', rule: '满99元包邮，不满收取8元' },
        { region: '香港地区', rule: '固定运费25港币' },
        { region: '美国地区', rule: '首重0.5kg/50元，续重0.5kg/20元' },
        { region: '欧洲地区', rule: '按实际物流商报价自动计算' },
      ],
      trackLabels: [
        { title: '国内仓', desc: '货物集中入库，进行铺货、清点与基础质检' },
        { title: '包装服务', desc: '定制加固包装，提升运输安全性，适配跨境标准' },
        { title: '海外仓', desc: '海外仓暂存，就近管理库存，缩短配送距离' },
        { title: '已收货', desc: '客户确认签收，订单闭环，全程物流服务完成' },
      ],
      manageItems: [
        { title: '20+物流商API同步', icon: require('@/assets/images/logistics/SmartManagement-1.png') },
        { title: '状态邮件/短信推送', icon: require('@/assets/images/logistics/SmartManagement-2.png') },
        { title: '滞留/异常自动预警', icon: require('@/assets/images/logistics/SmartManagement-3.png') },
        { title: '移动端实时查件', icon: require('@/assets/images/logistics/SmartManagement-4.png') },
      ],
      activeSolution: 0,
      solutionSteps: [
        { label: '国际专线&小包', desc: '云途、燕文、DHL等20+主流渠道，价格优、时效稳，覆盖欧美东南亚。', img: require('@/assets/images/logistics/SmartLogistics-1.png') },
        { label: '多仓智能调度', desc: '国内集货仓+海外前置仓+第三方仓API对接，系统自动匹配最优仓库发货。', img: require('@/assets/images/logistics/SmartLogistics-2.png') },
        { label: '智慧运费引擎', desc: '按重量/体积/地区/金额自动计算，支持阶梯运费、满额包邮等多种策略。', img: require('@/assets/images/logistics/SmartLogistics-3.png') },
        { label: '端到端追踪', desc: '实时同步1000+物流商轨迹，邮件/短信自动推送，异常预警提升体验。', img: require('@/assets/images/logistics/SmartLogistics-4.png') },
      ],
      whUnit: 260, // 偏移量 < 卡片宽度，使三张卡片重叠
      /* 运费演示交互 */
      demoWeight: 0.5,
      demoDest: '美国',
      presetWeights: [0.1, 0.5, 1, 2, 5, 10],
      demoDests: [{ name: '美国', rate: 0.6 }, { name: '英国', rate: 0.7 }, { name: '德国', rate: 0.65 }, { name: '澳大利亚', rate: 0.8 }],
      activeWarehouse: 0,
      warehouseCards: [
        { title: '国内操作中心', img: require('@/assets/images/logistics/MultiWarehouse-1.png'), lines: ['深圳、广州、义乌、郑州', '一件代发，集货打包', '自动分拣贴单，电子面单'] },
        { title: '海外仓核心布局', img: require('@/assets/images/logistics/MultiWarehouse-2.png'), lines: ['美国 (洛杉矶/新泽西) · 德国 · 英国 · 澳大利亚', '本地派送 2-3 日达', '退货处理/换标服务'] },
        { title: '第三方仓集成', img: require('@/assets/images/logistics/MultiWarehouse-3.png'), lines: ['通过API对接自有或合作仓，库存实时同步', '库存统一管理，避免超卖', '多仓履约，提升时效'] },
      ],
      faqs: [
        { q: '支持哪些国家的物流？', a: '目前主要覆盖美国（美西/美东）、德国、英国、澳大利亚，其他国家可根据需求对接第三方仓' },
        { q: '运费模板可以自定义多区域吗？', a: '完全可以。支持按国家/地区、邮编区域设置不同运费，也可针对商品单独设置运费规则。' },
        { q: '国际小包一般多久到？', a: '专线小包通常7-15个工作日妥投，商业快递3-5个工作日，具体因目的地和清关而异。' },
        { q: '多仓库如何管理库存？', a: '系统支持多仓库库存独立设置，可设置安全库存预警，订单创建后自动扣减对应仓库库存。' },
        { q: '是否支持电子面单批量打印？', a: '支持，与主流物流商API打通，可后台批量打印面单、拣货单，提升发货效率。' },
      ],
    }
  },
  mounted() {
    this.whUnit = window.innerWidth <= 1024 ? 220 : 260
    this._onWinResize = () => { this.whUnit = window.innerWidth <= 1024 ? 220 : 260 }
    window.addEventListener('resize', this._onWinResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._onWinResize)
  },
  computed: {
    stepImage() {
      const locale = this.$i18n.locale || 'zh-CN'
      return locale === 'en'
        ? require('@/assets/images/logistics/step-en.gif')
        : require('@/assets/images/logistics/step-zh.gif')
    },
    demoPrice() {
      const dest = this.demoDests.find(d => d.name === this.demoDest)
      const rate = dest ? dest.rate : 0.6
      const base = 8
      return (base + this.demoWeight * 15 * rate).toFixed(1)
    },
    trackOffset() {
      const step = 100 / 2.5;
      const maxOffset = this.solutionSteps.length * step - 100;
      return Math.min(this.activeSolution * step, Math.max(0, maxOffset));
    },
  },
  methods: {
    setSolution(idx) { this.activeSolution = idx },
    prevSolution() { if (this.activeSolution > 0) this.activeSolution-- },
    nextSolution() { if (this.activeSolution < this.solutionSteps.length - 1) this.activeSolution++ },
    /** 计算卡片相对于当前激活卡片的偏移位置: -1左 / 0中 / 1右 */
    whPosition(idx) {
      const n = this.warehouseCards.length
      let dist = idx - this.activeWarehouse
      if (dist > 1) dist -= n
      if (dist < -1) dist += n
      return dist
    },
    prevWarehouse() {
      this.activeWarehouse = (this.activeWarehouse - 1 + this.warehouseCards.length) % this.warehouseCards.length
    },
    nextWarehouse() {
      this.activeWarehouse = (this.activeWarehouse + 1) % this.warehouseCards.length
    },
    pad(n) { return String(n).padStart(2, '0') },
  },
}
</script>

<style scoped lang="scss">
/* ================================================================
   CSS 变量 — 设计令牌
   ================================================================ */
.logi {
  --c-primary: #7331ff;
  --c-primary-gradient: linear-gradient(360deg, #aa98fc 0%, #7331ff 100%);
  --c-text: #333333;
  --c-text-light: #666666;
  --c-text-muted: #999999;
  --c-white: #ffffff;
  --c-dark-bg: #f2f2f2;
  --max-w: 1200px;
  --r-sm: 4px;
  --r-md: 24px;
  --r-lg: 34px;

  background-color: var(--c-white);
  font-family: 'Source Han Sans CN', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* ================================================================
   1. Hero 横幅
   ================================================================ */
.logi-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 140px 20px 180px;
  background: url('~@/assets/images/logistics/hero-1.png') center no-repeat;
  background-size: cover;
  text-align: center;

  &__tag {
    display: inline-block;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 47px;
    padding: 8px 18px;
    font-size: 16px;
    color: #000;
    letter-spacing: 1px;
    margin: 0;
  }
  &__title { font-size: 48px; font-weight: 700; color: #fff; line-height: 1.35; margin: 16px 0 0; }
  &__desc { font-size: 14px; font-weight: 500; color: #fff; letter-spacing: 0.5px; max-width: 460px; line-height: 1.6; margin: 16px 0 0; }
  &__actions { display: flex; gap: 12px; margin-top: 40px; }
  &__btn {
    display: flex; align-items: center; justify-content: center; gap: 8px;
    border: none; cursor: pointer; font-size: 16px; font-weight: 500; border-radius: var(--r-lg);
    padding: 14px 36px; transition: opacity 0.15s;
    &:hover { opacity: 0.9; } &:active { opacity: 0.7; }

    &--primary { background: var(--c-primary-gradient); color: #fff; box-shadow: 0 4px 4px rgba(103,91,230,0.2); height: 50px; }
    &--outline { background: #fff; color: #0f2128; box-shadow: 0 4px 18px rgba(103,91,230,0.1);  height: 52px; img { width: 36px; height: 36px; } }
  }
}

/* ================================================================
   2. 三种履约模式
   ================================================================ */
.logi-modes {
  max-width: var(--max-w); margin: 0 auto; padding: 80px 20px;
  &__head { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 36px; }
  &__title { font-size: 30px; font-weight: 500; color: var(--c-text); margin: 0; }
  &__sub { font-size: 18px; color: var(--c-text-muted); margin: 8px 0 0; }
  &__cards { display: flex; gap: 24px; }
}
.logi-btn-primary {
  display: flex; align-items: center; gap: 12px;
  background: var(--c-primary-gradient); border: none; border-radius: var(--r-lg);
  color: #fff; font-size: 18px; height: 64px; padding: 0 32px; cursor: pointer;
  &:hover { opacity: 0.9; } img { width: 28px; height: 28px; }
}

.logi-mode-card {
  
  flex: 1 1 0%; display: flex; flex-direction: column; justify-content: space-between;
  border-radius: 0; background-size: cover; background-position: center;
  padding: 32px 20px 28px; min-height: 340px; cursor: pointer;
  transition: flex-grow 0.4s ease;

  &--line { background-image: url('~@/assets/images/logistics/ThreeFulfillment-1.png'); }
  &--warehouse { background-image: url('~@/assets/images/logistics/ThreeFulfillment-2.png'); }
  &--express { background-image: url('~@/assets/images/logistics/ThreeFulfillment-3.png'); }

  &--expanded { flex-grow: 3.55; }

  &__thumb { width: 48px; height: 48px; margin-bottom: 8px; opacity: 0; transition: opacity 0.3s; }
  &__title { font-size: 26px; font-weight: 500; color: #fff; margin: 0; line-height: 1.3; }
  &__body { overflow: hidden; opacity: 1; transition: opacity 0.3s; }
  &__desc { font-size: 14px; color: #fff; margin: 8px 0 0; line-height: 1.5; }
  &__feats { display: flex; flex-direction: column; gap: 12px; margin-top: 24px; }
  &__feat { display: flex; gap: 8px; img { width: 20px; height: 20px; flex-shrink: 0; margin-top: 2px; } div { display: flex; flex-direction: column; gap: 4px; font-size: 14px; color: #fff; line-height: 1.5; } }
  &__more { width: 28px; height: 28px; margin-top: 24px; }

  /* 收缩态：隐藏详情与箭头，显示缩略图，标题居左 */
  &:not(&--expanded) {
    padding-top: 120px; text-align: left;
    .logi-mode-card__body { opacity: 0; pointer-events: none; }
    .logi-mode-card__more { opacity: 0; pointer-events: none; }
    .logi-mode-card__thumb { opacity: 1; }
  }
}

/* ================================================================
   3. 全链路智慧物流解决方案
   左侧与上方模块对齐，右侧轮播直顶右边缘
   ================================================================ */
.logi-solution {
  position: relative; display: flex; min-height: 560px; color: #fff;
  background: url('~@/assets/images/logistics/SmartLogistics-bg.png') center no-repeat;
  background-size: cover;
  /* 左侧与 modes 模块 (max-width:1200px) 左对齐 */
  padding-left: calc((100vw - var(--max-w)) / 2 + 20px);

  &__bg {
    position: absolute; inset: 0; pointer-events: none; z-index: 0;
    background: linear-gradient(to right, rgb(82 69 110 / 87%) 0%, rgb(18 0 68 / 79%) 50%, transparent 50%, rgba(0, 0, 0, 0.2) 100%);
  }
  &__left { position: relative; z-index: 1; flex: 0 0 440px; padding: 100px 0 80px; }
  &__right { position: relative; z-index: 1; flex: 1; padding: 150px 0 80px 40px; display: flex; flex-direction: column; justify-content: center; min-width: 0; }
  &__title { font-size: 30px; font-weight: 700; margin: 0; line-height: 1.4; }
  &__sub { font-size: 14px; color: rgba(255,255,255,0.6); margin: 16px 0 0; line-height: 1.5; max-width: 300px; }

  /* 轮播：2.5 卡片可视 */
  &__carousel { overflow: hidden; flex: 1; }
  &__track { display: flex; gap: 20px; transition: transform 0.45s cubic-bezier(0.25, 0.1, 0.25, 1); }
  &__slide {
    flex: 0 0 calc(36% - 16px);
    display: flex; flex-direction: column;
    img { width: 100%;  object-fit: contain; border-radius: 12px; }//  aspect-ratio: 16/10;
    &-title { font-size: 28px; font-weight: 500; margin: -18px 0 0 18px; line-height: 1.3; }
    &-desc { font-size: 16px; line-height: 1.55; margin: 6px 0 0 18px; opacity: 0.75; word-break: break-word; }
  }
  /* 底部中心双箭头 */
  &__arrows { display: flex; justify-content: left; gap: 20px; margin-top: 28px;    margin-left: 50px; }
  &__arrow {
    width: 40px; height: 40px; border-radius: 5px; border: 2px solid rgba(255,255,255,0.5); background: transparent;
    display: flex; align-items: center; justify-content: center; cursor: pointer; transition: border-color 0.2s, opacity 0.2s;
    &:hover { border-color: #fff; }
    &:disabled { opacity: 0.3; cursor: default; }
  }
  &__arrow-icon {
    display: block; width: 10px; height: 10px; border-left: 2px solid #fff; border-bottom: 2px solid #fff;
    &--left { transform: rotate(45deg); margin-left: 3px; }
    &--right { transform: rotate(-135deg); margin-right: 3px; }
  }
}

.logi-steps {
  list-style: none; margin: 40px 0 0; padding: 0; display: flex; flex-direction: column; gap: 20px;

  &__item {
    display: flex; align-items: center; gap: 12px; padding: 14px 0; cursor: pointer;
    border: none;
    transition: color 0.2s;
    color: rgba(255,255,255,0.55);

    &--active {
      color: #fff;
      .logi-steps__num { background: var(--c-primary-gradient); border:none; }
      .logi-steps__label { border-bottom-color: #fff; }
    }
  }
  &__num { width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; border-radius: var(--r-sm); border: 2px solid rgba(255,255,255,0.4); font-size: 24px; font-weight: 700; flex-shrink: 0; transition: background 0.2s, border-color 0.2s; }
  &__label { font-size: 22px; font-weight: 500; border-bottom: 2px solid transparent; padding-bottom: 4px; transition: border-color 0.2s; white-space: nowrap; }
}

/* ================================================================
   4. 对接物流服务商
   ================================================================ */
.logi-partners {
  padding: 80px 0; text-align: center; overflow: hidden;
  &__title { font-size: 30px; font-weight: 700; color: var(--c-text); margin: 0; padding: 0 20px; }
  &__sub { font-size: 18px; color: var(--c-text-muted); margin: 8px 0 40px; padding: 0 20px; }
  /* 无缝跑马灯 */
  &__marquee { width: 100%; overflow: hidden; }
  &__track {
    display: flex; gap: 48px; width: max-content;
    animation: logi-marquee 15s linear infinite;
    img { height: 44px; object-fit: contain; flex-shrink: 0; }

    &:hover { animation-play-state: paused; }
  }
  &__full { width: 100%; max-width: 1000px; margin-top: 48px; }
}

@keyframes logi-marquee {
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
}

/* ================================================================
   5. 多仓智能网络
   ================================================================ */
.logi-warehouse {
  background: var(--c-dark-bg); padding: 60px 0; text-align: center;
  &__title { font-size: 30px; font-weight: 700; color: var(--c-text); margin: 0; padding: 0 20px; }
  &__sub { font-size: 18px; color: var(--c-text-muted); margin: 8px auto 48px; max-width: 620px; padding: 0 20px; }

  /* 3D 轮播容器 */
  &__carousel { display: flex; align-items: center; justify-content: center; gap: 16px; max-width: 1000px; margin: 0 auto; padding: 0 16px; }
  &__arrow {
    flex-shrink: 0; width: 44px; height: 44px; border-radius: 50%;
    background: #fff; border: 2px solid #eee; cursor: pointer;
    display: flex; align-items: center; justify-content: center; transition: box-shadow 0.2s;
    &:hover { box-shadow: 0 2px 12px rgba(0,0,0,0.12); }
    &-icon { display: block; width: 10px; height: 10px; border-left: 2px solid #333; border-bottom: 2px solid #333; }
    &--left &-icon { transform: rotate(45deg); margin-left: 3px; }
    &--right &-icon { transform: rotate(-135deg); margin-right: 3px; }
  }
  /* 舞台：相对定位容器，卡片绝对居中然后 translate 偏移 */
  &__stage { flex: 1; position: relative; height: 430px; overflow: hidden; }

  &__card {
    position: absolute; left: 50%; top: 30px; width: 340px; margin-left: -170px;
    background: #fff; border-radius: var(--r-md); overflow: hidden;
    box-shadow: 0 2px 12px rgba(0,0,0,0.04);
    img { width: 100%; height: 160px; object-fit: cover; }
    div { padding: 20px 24px; h4 { font-size: 18px; font-weight: 500; margin: 0 0 8px; } p { font-size: 14px; color: var(--c-text-light); margin: 2px 0; } }

    /* C位 */
    &--center {
      box-shadow: 0 8px 36px rgba(0,0,0,0.15);
    }
  }

  &__tip { display: flex; align-items: center; justify-content: center; gap: 8px; margin: 0; font-size: 18px; font-weight: 500; img { width: 24px; height: 24px; } }
  &__overseas { display: flex; align-items: center; justify-content: center; gap: 24px; max-width: 800px; margin: 40px auto 0; background: #fff; border-radius: var(--r-md); padding: 32px; box-shadow: 0 0 40px rgba(0,0,0,0.08); img { width: 120px; } div { text-align: left; } h4 { font-size: 20px; font-weight: 500; margin: 0; } p { font-size: 14px; color: var(--c-text-light); margin: 4px 0 0; } }
}

/* ================================================================
   6. 运费智能计算
   ================================================================ */
.logi-calc {
  max-width: var(--max-w); margin: 0 auto; padding: 80px 20px;
  &__title { font-size: 30px; font-weight: 700; text-align: center; margin: 0; }
  &__sub { font-size: 18px; color: var(--c-text-muted); text-align: center; margin: 8px 0 40px; }
  &__body { display: flex; gap: 40px; }
  &__methods { flex: 1; display: flex; flex-direction: column; gap: 16px; }
  &__method { background: #fafafa; border-radius: 12px; padding: 20px 24px; &-head { display: flex; align-items: center; gap: 12px; span { font-size: 18px; font-weight: 500; } } &-icon { font-size: 24px; line-height: 1; flex-shrink: 0; } p { font-size: 14px; color: var(--c-text-light); margin: 8px 0 0; } }

  /* 演示面板 */
  &__demo { flex: 0 0 40%; background: rgba(115,49,255,0.1); border-radius: 16px; padding: 24px; display: flex; flex-direction: column; h4 { font-size: 20px; font-weight: 500; margin: 0 0 16px; } &-inner { background: #fff; border-radius: 12px; padding: 28px 24px; flex: 1; display: flex; flex-direction: column; > label { display: block; font-size: 14px; color: var(--c-text-light); margin: 20px 0 8px; &:first-child { margin-top: 0; } } } }
  /* 滑块 */
  &__slider { display: flex; align-items: center; gap: 12px; background: #f5f5f5; border-radius: 8px; padding: 8px 14px; input[type=range] { flex: 1; accent-color: var(--c-primary); } &-val { font-size: 15px; font-weight: 600; color: var(--c-primary); min-width: 55px; text-align: right; } }
  /* 预设重量 */
  &__weights { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; span { font-size: 13px; padding: 6px 16px; border-radius: 20px; cursor: pointer; background: #f5f5f5; transition: background 0.15s, color 0.15s; &:hover { background: #e8e0ff; } } &--active { background: #e8e0ff; color: var(--c-primary); font-weight: 600; } }
  /* 目的地 */
  &__dests { display: flex; flex-wrap: wrap; gap: 8px; span { flex: 1; text-align: center; font-size: 13px; padding: 10px 8px; border-radius: 8px; cursor: pointer; background: #f5f5f5; transition: background 0.15s, color 0.15s; &:hover { background: #e8e0ff; } } &--active { background: #e8e0ff; color: var(--c-primary); font-weight: 600; } }
  /* 结果 — 撑满剩余空间 */
  &__result { margin-top: auto; text-align: center; padding: 28px 16px 12px; span { display: block; font-size: 13px; color: var(--c-text-muted); } strong { font-size: 42px; color: var(--c-primary); display: block; margin: 8px 0; font-weight: 700; } }

  /* 案例区 */
  &__case { margin-top: 48px; background: #fafafa; border-radius: 16px; padding: 32px; &-head { display: flex; align-items: center; gap: 12px; margin-bottom: 12px; span { font-size: 18px; font-weight: 500; } } &-dot { width: 10px; height: 10px; border-radius: 50%; background: var(--c-primary); flex-shrink: 0; } > p { font-size: 14px; color: var(--c-text-light); margin: 0 0 20px; } &-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; } &-item { background: #fff; border-radius: 12px; padding: 20px; strong { display: block; font-size: 16px; margin-bottom: 4px; } span { font-size: 14px; color: var(--c-text-light); } } &-tip { display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 24px; font-size: 14px; font-weight: 500; color: #7331FF; } }
}

/* ================================================================
   7. 实时追踪 — 胶囊轨道流程
   ================================================================ */
.logi-track {
  background: url('~@/assets/images/logistics/RealTime-1.png') center no-repeat;
  background-size: cover;
  padding: 80px 20px; text-align: center; color: #fff;

  &__title { font-size: 30px; font-weight: 700; margin: 0; }
  &__sub { font-size: 18px; opacity: 0.7; margin: 12px 0 56px; }

  /* 步骤流程图片 */
  &__img { display: block; max-width: 1000px; width: 100%; margin: 0 auto; }

  /* 下方说明 */
  &__labels { display: flex; justify-content: space-between; max-width: 1000px; margin: 32px auto 0; padding: 0 24px; }
  &__label { flex: 1; text-align: center; padding: 0 8px; strong { display: block; font-size: 15px; margin-bottom: 6px; } span { font-size: 13px; opacity: 0.7; line-height: 1.5; display: block; max-width: 200px; margin: 0 auto; } }
}

/* ================================================================
   响应式
   ================================================================ */
@media (max-width: 1024px) {
  .logi-track {
    &__img { max-width: 100%; }
    &__labels { flex-wrap: wrap; gap: 16px; }
    &__label { flex: 0 0 45%; }
  }
}

/* ================================================================
   8. 智能管理系统
   ================================================================ */
.logi-manage {
  max-width: var(--max-w); margin: 0 auto; padding: 80px 20px; text-align: center;
  &__title { font-size: 30px; font-weight: 700; margin: 0; }
  &__sub { font-size: 18px; color: var(--c-text-muted); margin: 8px 0 40px; }
  &__grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 2px; background: #fff; }
  &__card {
    display: flex; flex-direction: column; align-items: center; gap: 14px; padding: 36px 20px;
    background: #F7F7F7; cursor: pointer;
    transition: background 0.2s, transform 0.2s;
    &:hover { background: #fff; transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0,0,0,0.08); }
    img { width: 72px; height: 72px; object-fit: contain; }
    span { font-size: 15px; font-weight: 500; }
  }
  &__bar { width: 48px; height: 6px; background: #7331FF; margin-top: 14px; }
}

/* ================================================================
   9. 常见问题
   ================================================================ */
.logi-faq {
  max-width: var(--max-w); margin: 0 auto; padding: 60px 20px;
  &__title { font-size: 30px; font-weight: 700; text-align: center; margin: 0 0 32px; }
  &__list { max-width: 800px; margin: 0 auto; display: flex; flex-direction: column; gap: 12px; }
  &__item { border-bottom: 1px solid #eee; padding: 16px 0; dt { font-size: 18px; font-weight: 500; cursor: pointer; display: flex; justify-content: space-between; align-items: center; &::after { content: '+'; font-size: 22px; color: var(--c-text-muted); } } dd { font-size: 14px; color: var(--c-text-light); margin: 8px 0 0; line-height: 1.6; } }
}



/* ================================================================
   响应式
   ================================================================ */
@media (max-width: 1024px) {
  .logi-hero { padding: 100px 20px 140px; &__title { font-size: 36px; } }
  .logi-modes__cards { flex-direction: column; }
  .logi-mode-card { min-height: 260px; }
  .logi-solution { flex-direction: column; padding-left: 0; }
  .logi-solution__left { flex: auto; padding: 60px 20px 40px; }
  .logi-solution__right { padding: 0 20px 60px; }
  .logi-solution__slide { flex: 0 0 calc(50% - 10px); }
  .logi-calc__body { flex-direction: column; }
  .logi-calc__case-grid { grid-template-columns: repeat(2, 1fr); }
  .logi-track__img { max-width: 100%; }
  .logi-track__labels { flex-wrap: wrap; gap: 16px; }
  .logi-track__label { flex: 0 0 45%; }
  .logi-warehouse__card { width: 280px; margin-left: -140px; }
  .logi-warehouse__stage { height: 380px; }
}

@media (max-width: 768px) {
  .logi-hero { padding: 80px 16px 100px; &__title { font-size: 28px; } &__desc { font-size: 14px; } &__actions { flex-direction: column; } }
  .logi-modes__head { flex-direction: column; gap: 16px; }

  /* 移动端三个履约模式卡片全部展开 */
  .logi-mode-card {
    min-height: auto;
    &:not(.logi-mode-card--expanded) {
      padding-top: 32px;
      .logi-mode-card__body { opacity: 1; pointer-events: auto; }
      .logi-mode-card__more { opacity: 1; pointer-events: auto; }
      .logi-mode-card__thumb { opacity: 0; }
    }
    &--expanded { flex-grow: 1; }
  }

  /* 多仓网络切换按钮缩小 */
  .logi-warehouse__arrow {
    width: 32px; height: 32px;
  }
  .logi-warehouse__card { width: 240px; margin-left: -120px; }
  .logi-warehouse__stage { height: 360px; }

  .logi-calc__case-grid { grid-template-columns: 1fr; }
  .logi-manage__grid { grid-template-columns: repeat(2, 1fr); }
  .logi-track__img { max-width: 100%; }
  .logi-track__label { flex: 0 0 100%; }
 
}
</style>
